// import { setTimeout } from "core-js";

const state = {
    text: "",
    isShow: false,
    timeOutId:null
}

const getters = {
    get_text: (state) => {
        return state.text;
    },
    get_isShow: (state) => {
        return state.isShow;
    },
    get_timeOutId: (state) => {
        return state.timeOutId;
    },
}

const actions = {
    setText: (context, str) => {
        context.commit("SETTEXT", str);
    },
    showAlert: (context) => {
        context.commit("SHOWALERT");
    },
    hideAlert: (context) => {
        context.commit("HIDEALERT");
    },
    setTimeoutAlert: (context, arr) => {
        context.commit("SETTIMEROUTALERT", arr);
    },
}

const mutations = {
    SETTEXT: (state, str) => {
        state.text = str;
    },
    SHOWALERT: (state) => {
        state.isShow = true;
    },
    HIDEALERT: (state) => {
        state.isShow = false;
    },
    SETTIMEROUTALERT: (state, [str = "", num = 1100]) => {
        state.text = str;
        state.isShow = true;
        console.log(str);
        state.timeOutId = setTimeout(() => {
            state.text = "";
            state.isShow = false;
        }, num);
        console.log(state.timeOutId);
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}